import stringHelpers from "../../utilities/stringHelpers"
export const FormatDecimalChartTooltip = ({ active, data, label, isGroupedChart, colorsArray, tooltipCustomValueLabel, tooltipValuePrefix, tooltipValueSuffix, tooltipValueDecimalPrecision = 0 }) => {
    const tooltipData = data.find(item => item.label === label)
    return (
        <>
            {
                active &&
                <div className="custom-tooltip">
                    <p className='m-0'>{ label }</p>
                    {
                        tooltipData !== undefined &&
                        Object.entries(tooltipData)
                        .map(
                            ([key, value], index) => key !== "label" && 
                            <p className='mt-2 mb-0' style={{color: isGroupedChart ? colorsArray[index] : "#ff7e34"}}>{ !stringHelpers.isNullOrEmpty(tooltipCustomValueLabel) ? tooltipCustomValueLabel : key }: {!stringHelpers.isNullOrEmpty(tooltipValuePrefix) && tooltipValuePrefix }{ stringHelpers.formatDecimal(value, tooltipValueDecimalPrecision) }{!stringHelpers.isNullOrEmpty(tooltipValueSuffix) && tooltipValueSuffix}</p>
                        )
                    }
                </div>
            }
        </>
    )
}